import { render, staticRenderFns } from "./UploadAttachments.vue?vue&type=template&id=303ee5f4&scoped=true"
import script from "./UploadAttachments.vue?vue&type=script&lang=ts"
export * from "./UploadAttachments.vue?vue&type=script&lang=ts"
import style0 from "./UploadAttachments.scss?vue&type=style&index=0&id=303ee5f4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ee5f4",
  null
  
)

export default component.exports